import type { ParsedDepartment } from './excelParsers';

export interface ResolvedManagerEmailUpdate {
  entityId: string;
  managerEmail: string;
}

/**
 * Applies manually resolved manager emails onto department rows by
 * `entityId`. Used on both the departments DRAFT and (when one exists) its
 * flush baseline after a manual Manager-auflösen resolution — the draft alone
 * fixes the stale display (previously required a refresh to re-seed from the
 * server), and mirroring the same value onto the baseline keeps the row
 * reading as unchanged so autosave/Weiter don't re-send a pointless update
 * for a manager the backend already resolved this session.
 */
export function applyResolvedManagerEmails(
  rows: ParsedDepartment[],
  updates: ResolvedManagerEmailUpdate[]
): ParsedDepartment[] {
  if (updates.length === 0) return rows;
  const emailByEntityId = new Map(updates.map((update) => [update.entityId, update.managerEmail]));
  return rows.map((row) => {
    const managerEmail = row.entityId ? emailByEntityId.get(row.entityId) : undefined;
    return managerEmail === undefined ? row : { ...row, data: { ...row.data, managerEmail } };
  });
}
